var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1C14.9707 1 19 5.0293 19 10C19 14.9707 14.9707 19 10 19C5.0293 19 1 14.9707 1 10C1 5.0293 5.0293 1 10 1ZM10 2.2555C7.94603 2.2555 5.97619 3.07144 4.52381 4.52381C3.07144 5.97619 2.2555 7.94603 2.2555 10C2.2555 12.054 3.07144 14.0238 4.52381 15.4762C5.97619 16.9286 7.94603 17.7445 10 17.7445C12.054 17.7445 14.0238 16.9286 15.4762 15.4762C16.9286 14.0238 17.7445 12.054 17.7445 10C17.7445 7.94603 16.9286 5.97619 15.4762 4.52381C14.0238 3.07144 12.054 2.2555 10 2.2555ZM9.163 6.0229C9.5095 6.0229 9.7903 6.3046 9.7903 6.6511V11.0467H14.1859C14.3483 11.0528 14.502 11.1217 14.6147 11.2387C14.7274 11.3558 14.7903 11.512 14.7903 11.6744C14.7903 11.8369 14.7274 11.9931 14.6147 12.1102C14.502 12.2272 14.3483 12.2961 14.1859 12.3022H9.163C8.99639 12.3022 8.83661 12.236 8.7188 12.1182C8.60099 12.0004 8.5348 11.8406 8.5348 11.674V6.652C8.5348 6.3046 8.8156 6.0229 9.163 6.0229Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.788eee6dbd45028fd441f8eb5e47ac5d.svg";
export { ForwardRef as ReactComponent };